/**
 * NfceOfflineFiscalService
 *
 * Orquestra a geração e assinatura do XML NFC-e no PDV Desktop.
 * Chama os IPC handlers do processo principal (Electron).
 */
import { getElectronAPI } from "@/plugins/desktop";
import TerminalConfigService from "./TerminalConfigService";

const NfceOfflineFiscalService = {
  /**
   * Gera e assina o XML de uma NFC-e pelo seu UUID.
   *
   * @param {string} uuid_venda_terminal
   * @param {object} [opts]
   * @param {number} [opts.tpEmis] - 1=normal online, 9=contingência offline
   * @returns {Promise<object>} resultado do gerarXml
   */
  async gerarEAssinarXml(uuid_venda_terminal, opts = {}) {
    const api = getElectronAPI();
    if (!api) throw new Error("Electron API não disponível.");
    await TerminalConfigService.garantirConfiguracaoNfceLocal();

    const result = await api.nfce.gerarXml(uuid_venda_terminal, opts);
    await api.nfce.assinarXml(uuid_venda_terminal);
    return result;
  },
};

export default NfceOfflineFiscalService;
